// extracted by mini-css-extract-plugin
module.exports = {"item":"accordionItem__item--yEQME","link":"accordionItem__link--2O69O","content":"accordionItem__content--114Wd","img":"accordionItem__img--4HD5a"};